import { Typography, Box, Chip } from '@mui/material';

import { BffFacilityFieldsFragment } from '@/types/generated';

import { specialtyServicesStyles } from './SpecialtyServices.styles';

export default function SpecialtyServices({
	specialtyServices,
}: {
	specialtyServices: BffFacilityFieldsFragment['specialtyServices'];
}) {
	if (!specialtyServices?.length) return null;

	return (
		<Box data-testid="section_office_info_specialty_services">
			<Typography variant="bodySmallSemiBold" color="primary.main">
				Specialty services available:
			</Typography>
			<Box sx={specialtyServicesStyles}>
				{specialtyServices.reduce<React.ReactNode[]>((acc, item, index) => {
					if (!item?.name) return acc;
					return [
						...acc,
						<Box key={item.name || `specialty-service-${index}`}>
							<Chip
								data-testid={`chip_specialty_service_${index + 1}`}
								variant="lightInfo"
								label={item.name}
							/>
						</Box>,
					];
				}, [])}
			</Box>
		</Box>
	);
}
